import { render } from "./EventRegistrationPage.vue?vue&type=template&id=23f44468&scoped=true&ts=true"
import script from "./EventRegistrationPage.vue?vue&type=script&lang=ts"
export * from "./EventRegistrationPage.vue?vue&type=script&lang=ts"

import "./EventRegistrationPage.vue?vue&type=style&index=0&id=23f44468&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f44468"]])

export default __exports__